import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import type { Plazo } from '../../types';
import { abogadoPorId } from '../../data/abogados';
import { useDatos } from '../../contexts/DatosContext';
import { MarcaGoogle } from '../ui/Google';
import { etiquetaAnticipacion } from '../../utils/google';
import { diasRestantes, fechaCorta } from '../../utils/fechas';
import { nivelPorDias } from '../../utils/semaforo';
import { ChipDias, PuntoSemaforo } from '../ui/Semaforo';
import { EstadoVacio } from '../ui/Basicos';
export function ListaPlazos({
  plazos,
  puedeGestionar,
  onCumplir
}: {
  plazos: Plazo[];
  puedeGestionar: boolean;
  onCumplir: (id: string) => void;
}) {
  const {
    eventoGoogleDe,
    conexionGoogleDe
  } = useDatos();
  if (plazos.length === 0) {
    return <EstadoVacio mensaje="Sin términos registrados para este expediente" data-id="element-560" data-mp="114x8w1bual9a" />;
  }
  return <ul className="divide-y divide-gris-100" data-id="element-561" data-mp="w514w2356ttq">
      {plazos.map(p => {
      const dias = diasRestantes(p.fechaLimite);
      const responsable = abogadoPorId(p.responsableId);
      const evento = eventoGoogleDe('plazo', p.id);
      const conexion = conexionGoogleDe(p.responsableId);
      return <li key={p.id} className="flex flex-wrap items-center gap-4 px-5 py-3.5" data-id="element-562" data-mp="3kkg0v5es7rqr">
            {p.cumplido ? <CheckIcon className="h-4 w-4 shrink-0 text-exito-500" aria-hidden="true" data-id="element-563" data-mp="3pjkdk60x07lu" /> : <PuntoSemaforo nivel={nivelPorDias(dias)} data-id="element-564" data-mp="h3hh6wf965ct" />}
            <div className="min-w-0 flex-1" data-id="element-565" data-mp="l4symenz3k9x">
              <p className={`text-sm font-medium ${p.cumplido ? 'text-gris-400 line-through' : 'text-gris-800'}`} data-id="element-566" data-mp="l6nidpnid6cf">
                {p.concepto}
              </p>
              <p className="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-gris-500" data-id="element-567" data-mp="1023ioceolyh9">
                <span data-id="element-568" data-mp="14sjvbuaohg2k">
                  {p.tipo} · Responsable: {responsable?.nombre}
                </span>
                {evento && <MarcaGoogle titulo={`En Google Calendar de ${conexion.correoGoogle} · recordatorio ${etiquetaAnticipacion(evento.recordatorioMinutos)}`} data-id="element-569" data-mp="1enh8jxst49om" />}
              </p>
              {!p.cumplido && !evento && conexion.estado !== 'conectado' && <p className="mt-1 text-2xs text-ambar-700" data-id="element-570" data-mp="zqq9xqqyj202">
                  Sin recordatorio en Google:{' '}
                  <Link to={`/abogados/${p.responsableId}`} className="font-semibold underline" data-id="element-571" data-mp="vqzdb6er1rnm">
                    conectar la cuenta
                  </Link>{' '}
                  del responsable.
                </p>}
            </div>
            <div className="w-40 shrink-0 text-right" data-id="element-572" data-mp="h1a6aujz6tff">
              <p className="tabular text-xs font-medium text-gris-700" data-id="element-573" data-mp="gynqk7mxl7m4">
                {fechaCorta(p.fechaLimite)}
              </p>
              <div className="mt-1" data-id="element-574" data-mp="80bye16f21rk">
                {p.cumplido ? <span className="text-2xs font-semibold uppercase tracking-wide text-exito-700" data-id="element-575" data-mp="82g48onvlauh">
                    Cumplido
                  </span> : <ChipDias fechaLimite={p.fechaLimite} data-id="element-576" data-mp="2nng0xd4qxzxt" />}
              </div>
            </div>
            {puedeGestionar && !p.cumplido && <button type="button" onClick={() => onCumplir(p.id)} className="h-8 shrink-0 rounded border border-gris-200 px-2.5 text-xs font-medium text-gris-700 transition-colors duration-150 hover:border-marino-300 hover:text-marino-700" data-id="element-577" data-mp="2xngl11afwk32">
                Marcar cumplido
              </button>}
          </li>;
    })}
    </ul>;
}